import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';

@Pipe({
    name: 'permission',
    standalone: false
})
export class PermissionPipe implements PipeTransform {

  constructor(private permissionStorage: PermissionStorageService){}

  transform(permission: string): boolean {
    const currentPermissions = this.permissionStorage.getPermissions();
    return currentPermissions.includes(permission);
  }

}
